//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   SETTINGS
// import { _SETTINGS } from '../../config/settings';
///////////////////////////////////////////////////////////   COMPS
import WaveSurferPlayer from '../../components/audio-player/wavesurfer-player/wavesurfer-player.component';
//import './audio-player-page.style.scss';
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class AudioPlayerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (this.props.audioPlayer !== prevProps.audioPlayer) {
      this.setState({ audioPlayer: this.props.audioPlayer });
    }
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { audioPlayer } = this.state;
    return <div className='audioPageComponent'>{audioPlayer && <WaveSurferPlayer audioSettings={audioPlayer} />}</div>;
  }
}
